import React from "react";

const Diagnostics = () => {
  return (
    <div>
      <h1>Diagnostics</h1>
    </div>
  );
};

export default Diagnostics;
